import React from 'react';
import styled from 'styled-components';

const SmartSignals: React.FC = () => {
    return (
        <Container>
            <Title>Akıllı Sinyal</Title>
            <ComingSoon>Yakında Hizmetinizde!</ComingSoon>
        </Container>
    );
};

const Container = styled.div`
    padding: 24px;
`;

const Title = styled.h1`
    color: #E2E8F0;
    margin-bottom: 16px;
`;

const ComingSoon = styled.div`
    color: #3B82F6;
    font-size: 1.2rem;
`;

export default SmartSignals;